import React from 'react';
import styles from './HeroSection.module.css';
import HeroImage from '../../assets/images/hero-vector.svg';

const HeroSection = () => {
  return (
    <section className={styles.hero} id="inicio">
      <div className={styles.containerHero}>
        <div className={styles.textContent}>
          <h1>Engaje, recompense e valorize com experiências que conectam pessoas</h1>
          <p>Soluções eficazes para presentear, reconhecer ou criar relacionamento com pessoas em ações promocionais ou programas corporativos.</p>
          <a href="https://tally.so/r/3qXVr9" className={styles.button} target="_blank" rel="noopener noreferrer">Quero conhecer a Traily</a>
        </div>
        <div className={styles.imageContent}>
          <img src={HeroImage} alt="Hero Traily" />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
